import { CustomError } from './CustomError';

export class TwitchExtensionInitializationError extends CustomError {
	description = 'There was a problem registering Twitch Extension listeners';
	name = 'TwitchExtensionInitializationError';
}
